import itemData from './index_item'
import shopData from './index_shop'

const index = [itemData, shopData]

export default index 